import { render, staticRenderFns } from "./InfoautoEditCustomerModal.vue?vue&type=template&id=b1d80368"
import script from "./InfoautoEditCustomerModal.vue?vue&type=script&lang=js"
export * from "./InfoautoEditCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./InfoautoEditCustomerModal.vue?vue&type=style&index=0&id=b1d80368&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports